import React from "react"

// redux
import { connect } from "react-redux"
import { mapDispatchProps, mapStateToProps } from "../../store/store"

import BRAND from "../../constants/brand"
import CampaignIntroWholesale from "./introWholesale"
import CampaignIntroCommon from "./introCommon"
import CampaignIntroJp from "./introJp"
import { LOCALES } from "constants/locales"

const CampaignIntro = (props: any) => {
  if (process.env.LOCALE === LOCALES.JA) {
    return <CampaignIntroJp {...props} />
  }
  if (props.brand.businessType === BRAND.BUSINESS_TYPE.WHOLESALE) {
    return <CampaignIntroWholesale {...props} />
  }
  return <CampaignIntroCommon {...props} />
}

export default connect(mapStateToProps, mapDispatchProps)(CampaignIntro)
